export default "__VITE_ASSET__DEHuontI__"